import { Route } from "react-router-dom";
// import { useAuthorization } from "../contexts/AuthorizationContext";
// import SignIn from "../pages/login/SignIn";
// import CircularLoading from '../components/CircularLoading';

interface Props {
    element: any;
    path: string;
    children?: any;
}

export default function PrivateRoute({ element, path, children }: Props) {
    // const { isAutenticated, loading } = useAuthorization();
    // if (loading) element = <CircularLoading />
    // else if (!isAutenticated()) element = <SignIn />
    return <Route path={path} element={element}>{children}</Route>
}